import React from 'react';

import styles from '../styles.scss';

const SourceLost = () => <div className={styles.body}>Возможно, тендер был удален</div>;

export default SourceLost;
